<template>
  <v-snackbar
    v-model="show"
    :vertical="$vuetify.breakpoint.xs"
    :bottom="position === 'bottom'"
    :top="position === 'top'"
    :color="color"
  >
    {{ message }}
    <v-btn right text @click="show = false"> {{$t("snackbar.close")}} </v-btn>
  </v-snackbar>
</template>

<script>
export default {
  data() {
    return {
      show: false,
      message: "",
      color: "",
      position: "top",
    }
  },
  created() {
    this.$store.subscribe((mutation, state) => {
      if (mutation.type === "snackbar/SHOW_MESSAGE") {
        this.message = state.snackbar.content
        this.color = state.snackbar.color
        this.position = state.snackbar.position || "top"
        this.show = true
      }
    })
  },
}
</script>
